var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostIdentification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2522 14.201L12.3512 13.3352C12.1558 13.1474 11.8463 13.1492 11.6514 13.3377C11.3427 13.6364 10.9836 13.9792 10.7496 14.2019C10.5994 14.3449 10.5524 14.565 10.6322 14.7563C10.8246 15.2177 11.1964 16.1078 11.5406 16.9213C11.7121 17.3267 12.2836 17.3248 12.4546 16.9192L13.3665 14.7558C13.4469 14.565 13.4015 14.3445 13.2522 14.201Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8008 11.5C14.148 11.5 16.0508 9.59721 16.0508 7.25C16.0508 4.90279 14.148 3 11.8008 3C9.45357 3 7.55078 4.90279 7.55078 7.25C7.55078 9.59721 9.45357 11.5 11.8008 11.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8908 20.9985H12.3547L14.7916 12.707H15.8908C18.1804 12.707 20.0365 14.5631 20.0365 16.8528C20.0365 19.1424 18.1804 20.9985 15.8908 20.9985ZM8.14559 12.707H9.17306L10.1836 16.0531C9.7044 15.9932 9.07852 16.2208 9.07852 16.2208L6.77852 17.0208L4.57852 16.2208C4.57852 16.2208 4.361 16.1121 4.07812 16.0467C4.45327 14.1429 6.13174 12.707 8.14559 12.707ZM9.5988 20.9985H11.6772L10.559 17.296L9.5988 20.9985Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57867 17.8508C6.57867 17.7128 6.48456 17.5928 6.35285 17.5516C5.94863 17.425 5.37391 17.197 4.79918 16.9689C4.56431 16.8757 4.32945 16.7825 4.10622 16.6962C3.88218 16.6096 3.65841 16.8121 3.71766 17.0448L4.61619 20.5748C4.64082 20.6715 4.71198 20.7497 4.80602 20.7833L6.17777 21.2732C6.37314 21.343 6.57867 21.1981 6.57867 20.9907V17.8508Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0791 20.9755C7.0791 21.183 7.28462 21.3278 7.48 21.2581L8.81483 20.7813C8.90801 20.7481 8.97879 20.671 9.00402 20.5753L9.92241 17.0917C9.9861 16.8501 9.74356 16.6396 9.51221 16.734C8.80574 17.0223 7.89203 17.3736 7.30685 17.5458C7.17399 17.5849 7.0791 17.7052 7.0791 17.8437V20.9755Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostIdentification);
export default __webpack_public_path__ + "static/media/host-identification.0bcb0cfc.svg";
export { ForwardRef as ReactComponent };